// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1jeKm","resendInfoText":"OnGoingPaymentBox_resendInfoText__3eHhP"};